/**
 * 
 */

$(function() {
	$(window).on('scroll', function() {
		let scrollHeight = $(document).height();
		let scrollPosition = $(window).height() + $(window).scrollTop();
		let footHeight = $("footer").innerHeight();
		if (scrollHeight - scrollPosition <= footHeight) {
	    	$("#faqButton").css({ position: "absolute", bottom: `calc(${footHeight} + 1vw)` });
	    } else {
	    	$("#faqButton").css({ position: "fixed", bottom: "1vw" });
	    }
	})
})